export const EXCHANGE_AND_PROGRAMS_NAMES = {
    exchangeName: 'common.exchange_name',
    exchangeMedicaid: 'common.exchange_medicaid_name',
    exchangeChip: 'common.exchange_chip_name',
    exchangeMedicaidOrChip: 'common.exchange_medicaid_or_chip_name',
    exchangeMedicaidAndChip: 'common.exchange_medicaid_and_chip_name',
    exchangeMedicaidSlashChip: 'common.exchange_medicaid_slash_chip_name',
    exchangeBasicHealthProgram: 'common.exchange_basic_health_program_name',
    defaultExchangeMedicaid: 'common.exchange_medicaid_default_name',
    defaultExchangeChip: 'common.exchange_chip_default_name',
    defaultExchangeMedicaidAndChip: 'common.exchange_medicaid_and_chip_default_name',
    defaultExchangeMedicaidOrChip: 'common.exchange_medicaid_or_chip_default_name',
    defaultExchangeMedicaidSlashChip: 'common.exchange_medicaid_slash_chip_default_name',
};